(function() { window.GUID_111d3f7b_5638_4ced_a656_d634998e5b66 = { getGuid: function() { return "111d3f7b-5638-4ced-a656-d634998e5b66"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class EventDropdown extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.ControlId}`);
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
            }
            OnBindEvents() {
                const shouldBindEvent = !CS.DOM.$body.hasClass("controller-streamswall") &&
                    !CS.DOM.$body.hasClass("controller-leaderboard") &&
                    !CS.DOM.$body.hasClass("controller-gameswall") &&
                    !CS.DOM.$body.hasClass("action-selecteventforhelp");
                if (shouldBindEvent) {
                    Controls.DropDown.Events.ListItemClicked({
                        selector: "[class*=autocomplete-find-events-event-drpdwn]:not(#dropdown-autocomplete-find-events-event-drpdwn-csr-wall-events):not(#dropdown-autocomplete-find-events-event-drpdwn-help):not(#dropdown-autocomplete-find-events-children-picker)",
                        callback: (list, e) => {
                            const extraValues = e.data.extraValues;
                            if (extraValues != null) {
                                const { Url } = extraValues;
                                if (Url != null) {
                                    CS.Nav.Go(Url);
                                }
                            }
                        },
                    });
                }
            }
            OnDispose() { }
        }
        Controls.EventDropdown = EventDropdown;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=event-dropdown.js.map
